import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getBlackBelts } from '../view/HTTPService';

/**
 * /blackbelts - Lista de faixas pretas.
 */
export default function BlackbeltsPage() {
    return (
        <AffiliateList
            titleKey="msg.jkaBlackBelts"
            fetchAffiliates={getBlackBelts}
        />
    );
}
